var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("流程格式"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("保存"),
      cancelText: _vm.$t("取消"),
      width: 1000
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("div", {
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _c("a-table", {
      attrs: {
        bordered: "",
        columns: _vm.columns,
        "data-source": item.terms,
        align: "center",
        pagination: false,
        rowKey: "id"
      },
      scopedSlots: _vm._u([{
        key: "display",
        fn: function (text, record) {
          return [_c("a-select", {
            staticStyle: {
              width: "150px"
            },
            attrs: {
              placeholder: _vm.$t("请选择"),
              allowClear: ""
            },
            model: {
              value: record.display,
              callback: function ($$v) {
                _vm.$set(record, "display", $$v);
              },
              expression: "record.display"
            }
          }, [_c("a-select-option", {
            attrs: {
              value: 1
            }
          }, [_vm._v(_vm._s(_vm.$t("PDF")))]), _c("a-select-option", {
            attrs: {
              value: 2
            }
          }, [_vm._v(_vm._s(_vm.$t("文本")))])], 1)];
        }
      }, {
        key: "limit",
        fn: function (text, record, index2) {
          return [_c("a-select", {
            staticStyle: {
              width: "150px"
            },
            attrs: {
              placeholder: "请选择",
              allowClear: ""
            },
            on: {
              change: function ($event) {
                return _vm.displayChange(index, index2);
              }
            },
            model: {
              value: record.limit,
              callback: function ($$v) {
                _vm.$set(record, "limit", $$v);
              },
              expression: "record.limit"
            }
          }, [_c("a-select-option", {
            attrs: {
              value: 1
            }
          }, [_vm._v(_vm._s(_vm.$t("无限制")))]), _c("a-select-option", {
            attrs: {
              value: 2
            }
          }, [_vm._v(_vm._s(_vm.$t("下拉到页面底部")))]), _c("a-select-option", {
            attrs: {
              value: 3
            }
          }, [_vm._v(_vm._s(_vm.$t("强制阅读")))]), _c("a-select-option", {
            attrs: {
              value: 4
            }
          }, [_vm._v(_vm._s(_vm.$t("勾选同意")))])], 1)];
        }
      }, {
        key: "time",
        fn: function (text, record) {
          return [_c("div", {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "justify-content": "center"
            }
          }, [_c("a-input-number", {
            staticStyle: {
              "margin-right": "10px",
              width: "150px"
            },
            attrs: {
              placeholder: _vm.$t("输入限制：单值"),
              allowClear: "",
              disabled: record.limit == 3 ? false : true
            },
            model: {
              value: record.time,
              callback: function ($$v) {
                _vm.$set(record, "time", $$v);
              },
              expression: "record.time"
            }
          }), _vm._v("s ")], 1)];
        }
      }], null, true)
    }, _vm._l(_vm.columns, function (item, i) {
      var _item$slots, _item$slots2, _item$slots3;
      return _c("span", {
        key: i,
        attrs: {
          slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
        },
        slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
      }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
    }), 0)], 1);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };